import { FormattedMessage } from "react-intl";

import { Text } from "@ps-design-system/components/Text";
import { TextareaField } from "@ps-design-system/components/Textarea";

import { useIntl } from "react-intl-compat";

const DescriptionField = () => {
  const intl = useIntl();

  return (
    <div className="tw-flex tw-flex-col tw-gap-16">
      <div className="tw-flex tw-flex-col tw-gap-8">
        <Text typeface="headline-4-b" element="h2" className="tw-m-0">
          <FormattedMessage
            id="hosting.space_details.description_header"
            defaultMessage="Add a description for your space"
          />
        </Text>
        <Text typeface="body-2" element="p" className="tw-m-0">
          <FormattedMessage
            id="hosting.space_details.description_text"
            defaultMessage="Include details about your space so that guests will know everything it offers."
          />
        </Text>
      </div>

      <div>
        <Text typeface="body-2-m">
          <FormattedMessage
            id="hosting.space_details.description_question_header"
            defaultMessage="Try to answer questions like:"
          />
        </Text>
        <ul className="tw-list-disc tw-list-inside tw-m-0">
          <Text element="li">
            <FormattedMessage
              id="hosting.space_details.description_question_activities"
              defaultMessage="What activities work well in your space?"
            />
          </Text>
          <Text element="li">
            <FormattedMessage
              id="hosting.space_details.description_question_layout"
              defaultMessage="What is the layout of the space and how can different areas be used?"
            />
          </Text>
          <Text element="li">
            <FormattedMessage
              id="hosting.space_details.description_question_features"
              defaultMessage="What unique features or amenities does your space have?"
            />
          </Text>
        </ul>
      </div>

      <div>
        <Text typeface="body-2-m">
          <FormattedMessage
            id="hosting.space_details.description_do_not_include"
            defaultMessage="Do not include:"
          />
        </Text>
        <ul className="tw-list-disc tw-list-inside tw-m-0">
          <Text element="li">
            <Text typeface="body-2-m">
              <FormattedMessage
                id="hosting.space_details.description_do_not_include_contact_information"
                defaultMessage="Contact information"
              />
            </Text>
            {" - "}
            <Text typeface="body-2">
              <FormattedMessage
                id="hosting.space_details.description_do_not_include_contact_information_details"
                defaultMessage="Do not include your phone number, venue name, address, email, or links to your website."
              />
            </Text>
          </Text>
        </ul>
      </div>

      <div>
        <Text
          element="a"
          href="https://support.peerspace.com/hc/en-us/articles/206400895-What-should-I-add-to-the-About-the-Space-section-of-my-listing-"
          target="_blank"
          rel="noreferrer"
          className="tw-underline"
        >
          <FormattedMessage
            id="hosting.space_details.example_description_link"
            defaultMessage="Example description"
          />
        </Text>
      </div>

      <TextareaField
        fullWidth
        name="description"
        placeholder={intl.formatMessage({
          id: "hosting.space_details.description_input",
          defaultMessage: "Enter your space description",
        })}
        note={intl.formatMessage({
          id: "hosting.space_details.description_char_min",
          defaultMessage: "Minimum 280 characters",
        })}
        testId="space-details-form-description-input"
      />
    </div>
  );
};

export { DescriptionField };
